const breakpoints = {
  xs: 450,
  sm: 540,
  md: 768,
  lg: 992,
  xl: 1200
}

export default breakpoints
